export function TvOfflineOverlay({ telaNome }: { telaNome: string }) {
  return (
    <div role="status" aria-live="polite" className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-jukebox-bg/98 backdrop-blur-lg px-8">
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-orange-500/[0.06] rounded-full blur-3xl animate-standby-breathe" />
      </div>

      <div className="relative mb-8">
        <div className="absolute inset-0 rounded-full bg-orange-500/15 animate-ping" />
        <div
          className="relative w-24 h-24 rounded-full bg-white/[0.05] border border-white/[0.08] flex items-center justify-center"
          style={{ boxShadow: '0 24px 48px rgba(0,0,0,0.6), inset 0 1px 0 rgba(255,255,255,0.08), inset 0 -1px 0 rgba(0,0,0,0.15)' }}
        >
          <svg className="w-10 h-10 text-white/25" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 20h12M8 20v-1a4 4 0 014-4h0a4 4 0 014 4v1M2 7h20M4 7V5a1 1 0 011-1h14a1 1 0 011 1v2" />
          </svg>
        </div>
      </div>

      <p className="mb-2 text-[11px] font-medium text-white/50">Palco · aguardando</p>
      <h2 className="mb-2 text-center text-xl font-bold text-white">{telaNome}</h2>
      <p className="mb-6 text-center text-sm text-white/55">A TV precisa estar no ar para pedidos.</p>

      <div className="w-48 h-1 bg-white/[0.06] rounded-full overflow-hidden">
        <div className="h-full bg-gradient-to-r from-orange-500 to-rose-500 rounded-full animate-tv-wait" />
      </div>

      <p className="text-white/50 text-xs mt-6 text-center max-w-xs">
        O Player da TV precisa estar aberto para você poder fazer pedidos.
      </p>
    </div>
  );
}
